// Convert respect points to PR currency
// 100 Respect = 0.0001 PR
export const respectToPR = (respectPoints) => {
  const prValue = (respectPoints / 100) * 0.0001
  return prValue.toFixed(8) // Show 8 decimal places
}

// Format PR with proper decimal places
export const formatPR = (respectPoints) => {
  const prValue = respectToPR(respectPoints)
  // Remove trailing zeros but keep at least 4 decimal places
  const formatted = parseFloat(prValue).toFixed(8)
  return formatted.replace(/\.?0+$/, '')
}
